export const BROADCAST_MESSAGE = 'BROADCAST_MESSAGE';
export const BROADCAST_MESSAGE_READ = 'BROADCAST_MESSAGE_READ';

export const broadcastMessageRead = () => dispatch =>
  dispatch({
    type: BROADCAST_MESSAGE_READ
  });
